<template>
    <div
        class="mb-3 clearfix list-group border-radius-2 no-border"
        @click="$emit('click', activity)"
        :style="{cursor: disabled ? 'default' : 'pointer'}"
    >
        <div class="list-group-item">
            <p class="mt-0 mb-0 small">
                <strong>
                    {{ $datetime.getRelativeStringFromTimeStamp(activity.datetime, false) }}
                </strong>
            </p>
            <div v-if="activity.child" class="list-group border-radius-1 no-border mt-2 mb-2">
                <div class="list-group-item list-group-item-info p-2">
                    {{activity.child.title}}
                    {{activity.child.datetime}}
                </div>
            </div>
            <div v-if="activity.reflection && activity.reflection.trim()" ass="mt-0 mb-0" style="white-space: pre-wrap">
                <p><strong>{{ $t('students-reflection-colon') }}</strong> {{activity.reflection.trim()}}</p>
            </div>
            <div v-if="activity.feedback">
                <p>
                    <span class="badge rounded-circle bg-success d-inline-flex align-items-center justify-content-center mr-2" style="width: 24px; height: 24px; padding: 0;">
                        <b-icon icon="chat-left-quote" scale="1" variant="white"></b-icon>
                    </span>
                    <strong>{{ $t('feedback-colon') }}</strong> {{activity.feedback.trim()}}
                </p>
                <p class="sm"><small>{{ $t('submitted-by') }} {{ activity.teacher_displayname }}</small></p>
            </div>
            <div v-if="activity.treatmentsessions">
                <div v-for="(treatmentsession, index) in activity.treatmentsessions"
                        :key="index">
                    <div v-if="treatmentsession.teacherFeedback && treatmentsession.teacherFeedback.trim()" ass="mt-0 mb-0" style="white-space: pre-wrap">
                        <p><strong>{{ $t('teachers-reflection-colon') }}</strong> {{treatmentsession.teacherFeedback.trim()}}</p>
                    </div>
                    <div
                        class="mt-2 mb-2 p-1 pl-2 pr-2 alert alert-info"
                        style="cursor: pointer;"
                        @click.stop="$router.push(`/clinical/treatmentsession/${treatmentsession.id}`)"
                    >
                        {{$datetime.getLocaleStringFromTimeStamp(treatmentsession.treatmentTimestamp)}} |
                        {{$config.getSpecialtyNameById(treatmentsession.specialty_id)}} |
                        {{$config.getClinicNameById(treatmentsession.clinic_id)}} |
                        {{$config.getParticipationTypeNameById(treatmentsession.participationtype_id)}}
                    </div>
                </div>  
            </div>
            <div v-if="activity.formresponses">
                <div
                	v-for="(formresponse, index) in activity.formresponses"
                	:key="index"
                	class="mt-2 mb-2 p-1 pl-2 pr-2 alert alert-info"
                	style="cursor: pointer;"
                	@click.stop="$router.push(`/forms/view/${formresponse.id}`)"
                >
                    <b-icon icon="file-earmark-text" scale="1" class="mr-1"></b-icon>
                	Form: {{formresponse.form.title}} |
                	{{$datetime.getLocaleStringFromTimeStamp(formresponse.dateofresponse, false)}}
                </div>
            </div>
            
            <div v-if="activity.competencytestsessions && $config.hasModule('tests')">
                <div
                	v-for="(testsession, index) in activity.competencytestsessions"
                	:key="index"
                	class="mt-2 mb-2 p-1 pl-2 pr-2 alert alert-info"
                	style="cursor: pointer;"
                    @click.stop="$router.push(`/tests/${testsession.id}`)"
                >
                    <b-icon icon="award" scale="1" class="mr-1"></b-icon>
                	Test:
                	{{testsession.competencytest.code}}
                	{{testsession.competencytest.title}}
                	|
                	{{$datetime.getLocaleStringFromTimeStamp(testsession.DateTaken, false)}}
                </div>
            </div>
            <div v-if="activity.assets" class="d-flex flex-row align-items-center flex-wrap">
				<template v-for="asset in activity.assets">
					<img
						v-if="isImage(asset)"
						:key="asset.id"
						:src="getAssetURL(asset)"
						class="img-fluid"
						:alt="asset.asset_title"
						style="cursor: pointer;"
						@click.stop="goToAssetViewUrl(asset)"
					>
					<AssetBadge
						v-else
						:file="asset"
						:key="asset.id"
						class="mr-2"
						@click="goToAssetViewUrl(asset)"
						style="cursor: pointer;"
					/>
				</template>
            </div>
            <div v-if="activity.tags">
                <span v-for="(tag, index) in activity.tags" :key="index" class="badge badge-primary mr-2">{{tag.name}}</span>
            </div>
            <div v-if="activity.learningoutcomes">
                <span v-for="(learningoutcome, index) in activity.learningoutcomes" :key="index" class="badge badge-secondary mr-2" style="max-width: 100%; overflow:hidden; text-overflow:ellipsis">
                	<template v-if="learningoutcome.code">{{learningoutcome.code}}: </template>
                	{{learningoutcome.title}}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import AssetBadge from '../../components/Asset/AssetBadge.vue'
export default {
    props: {
        activity: Object,
        disabled: Boolean
    },
    components: {
        AssetBadge,
    },
    methods: {
    	isImage: function(item) {
    		return (
    			item.asset_extension == 'jpg' ||
				item.asset_extension == 'jpeg' ||
				item.asset_extension == 'png' ||
				item.asset_extension == 'gif'
			);
    	},
    	getAssetURL: function(item) {
    		return `${this.$settings.APIBaseURL}/asset/fetch/${item.asset_id}.${
				item.asset_extension
			}?username=${this.$UserSession.getValue.call(
				this,
				"username"
			)}&authToken=${this.$UserSession.getValue.call(this, "authToken")}`;
    	},
        goToAssetViewUrl(item) {
            window.location.assign(this.getAssetURL(item));
		},
    }
}
</script>
